import { expVal } from '@confluence/feature-experiments';

import { GetLicensedProductsQuery } from './GetLicensedProductsQuery.graphql';
import { GetLicensedProducts } from './GetLicensedProducts.graphql';

export const getLicensedProductsQuery = () => {
	return expVal('confluence_consolidate_licensed_product_queries', 'isEnabled', false)
		? GetLicensedProductsQuery
		: GetLicensedProducts;
};
